import { UserRestriction } from '@/models/user-restriction';
import { Restriction } from '@/models/restriction';
import { Nullable } from '@starsoft/common/interfaces';

export function getLottie(
  userRestrictions: Array<UserRestriction>,
  restriction: Nullable<Restriction>,
) {
  return userRestrictions.length > 0 || !!restriction
    ? 'restricitons.json'
    : 'celebration.json';
}
